import { deleteRequest, getRequest, postRequest, putRequest } from "./ApiRequest";

// Ordini asporto e consegna (modulo "orders"): risposte JSON dirette, errori in `message`.
const O = "orders";
export const GetOrderSettingsAPI = () => getRequest(`${O}/settings`);
export const SaveOrderSettingsAPI = (p) => putRequest(`${O}/settings`, p);
export const GetOrderHoursAPI = () => getRequest(`${O}/hours`);
export const SaveOrderHoursAPI = (hours) => putRequest(`${O}/hours`, { hours });
export const GetZonesAPI = () => getRequest(`${O}/zones`);
export const AddZoneAPI = (p) => postRequest(`${O}/zones`, p);
export const SaveZoneAPI = (id, p) => putRequest(`${O}/zones/${id}`, p);
export const DeleteZoneAPI = (id) => deleteRequest(`${O}/zones/${id}`);
export const GetPromotionsAPI = () => getRequest(`${O}/promotions`);
export const AddPromotionAPI = (p) => postRequest(`${O}/promotions`, p);
export const SavePromotionAPI = (id, p) => putRequest(`${O}/promotions/${id}`, p);
export const DeletePromotionAPI = (id) => deleteRequest(`${O}/promotions/${id}`);
export const GetChannelsAPI = () => getRequest(`${O}/channels`);
export const SaveChannelsAPI = (dishes) => putRequest(`${O}/channels`, { dishes });
export const GetOrdersAPI = (status = "open") => getRequest(`${O}/?status=${status}`);
export const AcceptOrderAPI = (id, minutes) => postRequest(`${O}/${id}/accept`, { minutes });
export const RejectOrderAPI = (id, reason) => postRequest(`${O}/${id}/reject`, { reason });
export const SetOrderStatusAPI = (id, status) => postRequest(`${O}/${id}/status`, { status });
export const StripeStatusAPI = () => getRequest(`${O}/stripe/connect`);
export const StripeConnectAPI = (return_url) => postRequest(`${O}/stripe/connect`, { return_url });
export const GetCampaignsAPI = () => getRequest(`${O}/campaigns`);
export const SaveCampaignAPI = (kind, p) => putRequest(`${O}/campaigns/${kind}`, p);
export const GetCustomersCsvAPI = () => getRequest(`${O}/customers.csv`);

export const GetOrderStatsAPI = (days = 7) => getRequest(`${O}/stats?days=${days}`);
